import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { Box, Button, CardMedia, Typography, IconButton } from "@mui/material";

import {
  ArrowForwardIos,
  Videocam,
  AutoAwesomeMotion,
} from "@mui/icons-material";

import { useMedia } from "@/services/hooks";

// Styles for the grid container
const gridContainerStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(3, 1fr)", // Three columns
  gap: "5px", // Space between images
  mt: 2,
  pl: 0,
};

// Styles for each grid item to ensure they are square
const gridItemStyle = {
  paddingTop: "100%", // 1:1 aspect ratio
  position: "relative",
};

// Styles for the image
const imageStyle = {
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  objectFit: "cover", // Keep aspect ratio of image
  WebkitTouchCallout: "none",
  WebkitUserSelect: "none",
  KhtmlUserSelect: "none",
  MozUserSelect: "none",
  msUserSelect: "none",
  userSelect: "none",
};

export default function MediaContainer({ artistKey }) {
  const navigate = useNavigate();
  const { data: artistContent } = useMedia(artistKey);

  const [limit, setLimit] = useState(9);

  const handleMediaClick = (content) => {
    navigate(`/${artistKey}/media?contentKey=${content.key}`);
    // window.location.href = `/media?contentKey=${content.key}`;
  };

  const preventLongPressMenu = (e) => {
    e.preventDefault();
    e.stopPropagation();
    return false;
  };

  if (artistContent?.length === 0) {
    return null;
  }
  return (
    <>
      {artistContent?.length > 0 && (
        <Box
          id="media"
          sx={{
            p: 2,
            pb: 8,
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography variant="h6" sx={{ my: 4, fontWeight: 800 }}>
              Media
            </Typography>
            <Box>
              <IconButton onClick={() => navigate(`/${artistKey}/media`)}>
                <ArrowForwardIos />
              </IconButton>
            </Box>
          </Box>
          <Box sx={gridContainerStyle}>
            {artistContent?.slice(0, limit).map((content, index) => (
              <div
                key={index}
                style={gridItemStyle}
                onClick={() => handleMediaClick(content)}
              >
                {content.type == "video" && (
                  <>
                    <CardMedia
                      component="img"
                      src={content.meta["cover"]}
                      alt={content.title}
                      style={imageStyle}
                      sx={{
                        "&:hover": {
                          filter: "brightness(0.5)",
                        },
                      }}
                      onContextMenu={preventLongPressMenu}
                      // onTouchStart={preventLongPressMenu}
                      // onTouchEnd={preventLongPressMenu}
                      // onTouchMove={preventLongPressMenu}
                      // onMouseDown={preventLongPressMenu}
                    />
                    <Box
                      style={{
                        position: "absolute",
                        top: "0",
                        right: "0",
                        margin: "8px",
                      }}
                    >
                      <Videocam style={{ fontSize: "20px" }} />
                    </Box>
                  </>
                )}
                {content.type == "carousel" && (
                  <>
                    <CardMedia
                      image={content.meta.urls[0]}
                      style={imageStyle}
                      sx={{
                        "&:hover": {
                          filter: "brightness(0.5)",
                        },
                      }}
                      onContextMenu={preventLongPressMenu}
                      // onTouchStart={preventLongPressMenu}
                      // onTouchEnd={preventLongPressMenu}
                      // onTouchMove={preventLongPressMenu}
                      // onMouseDown={preventLongPressMenu}
                    />
                    <Box
                      style={{
                        position: "absolute",
                        top: "0",
                        right: "0",
                        margin: "8px",
                      }}
                    >
                      <AutoAwesomeMotion style={{ fontSize: "18px" }} />
                    </Box>
                  </>
                )}
                {content.type == "image" && (
                  <CardMedia
                    component="img"
                    image={content.meta["url"]}
                    alt={content.title}
                    style={imageStyle}
                    sx={{
                      "&:hover": {
                        filter: "brightness(0.5)",
                      },
                    }}
                    onContextMenu={preventLongPressMenu}
                    // onTouchStart={preventLongPressMenu}
                    // onTouchEnd={preventLongPressMenu}
                    // onTouchMove={preventLongPressMenu}
                    // onMouseDown={preventLongPressMenu}
                  />
                )}
              </div>
            ))}
          </Box>
          {
            // Show "Load More" button if there are more than 9 media items
            artistContent?.length > limit && (
              <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
                <Button onClick={() => setLimit(limit + 36)} variant="text">
                  Load More
                </Button>
              </Box>
            )
          }
        </Box>
      )}
    </>
  );
}
